// Google Analytics utility functions
// Your Google Analytics Measurement ID: G-2Q691Z402E

export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-2Q691Z402E';

// Initialize Google Analytics
export const initGA = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_title: document.title,
      page_location: window.location.href,
    });
  }
};

// Track page views
export const trackPageView = (url) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: url,
      page_title: document.title,
      page_location: window.location.href,
    });
  }
};

// Track custom events
export const trackEvent = (action, category = 'General', label = null, value = null) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track specific events for your portfolio
export const trackProjectView = (projectName) => {
  trackEvent('project_view', 'Portfolio', projectName);
};

export const trackContactClick = (method) => {
  trackEvent('contact_click', 'Engagement', method);
};

export const trackDownload = (fileName) => {
  trackEvent('file_download', 'Downloads', fileName);
};

export const trackSocialClick = (platform) => {
  trackEvent('social_click', 'Social', platform);
};

// Track scroll depth (optional)
export const trackScrollDepth = (depth) => {
  trackEvent('scroll_depth', 'Engagement', null, depth);
};

// Track time on page (optional)
export const trackTimeOnPage = (timeInSeconds) => {
  trackEvent('time_on_page', 'Engagement', null, timeInSeconds);
};
